import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Calculator, MessageCircle } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

const HIDDEN_PATHS = ["/cost-calculator"];

export default function StickyQuoteBar() {
  const location = useLocation();
  const { lang } = useLang();
  const [whatsapp, setWhatsapp] = useState("+52 999 361 6898");

  useEffect(() => {
    api.get("/brand").then((r) => { if (r.data.whatsapp) setWhatsapp(r.data.whatsapp); }).catch(() => {});
  }, []);

  if (HIDDEN_PATHS.includes(location.pathname)) return null;
  const digits = whatsapp.replace(/[^0-9]/g, "");
  const prefill = lang === "es"
    ? "Hola!%20Tengo%20una%20pregunta%20sobre%20mudarme%20a%20M%C3%A9xico."
    : "Hola!%20I%20have%20a%20question%20about%20moving%20to%20Mexico.";

  return (
    <>
      <div className="h-16 lg:hidden" aria-hidden="true" />
      <div
        data-testid="sticky-quote-bar"
        className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-white/95 backdrop-blur-md border-t border-sand-300 px-4 py-2.5 flex gap-3 shadow-[0_-4px_16px_rgba(44,42,41,0.1)]"
        style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
      >
        <Link
          to="/cost-calculator"
          data-testid="sticky-bar-quote"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-terracotta px-4 py-2.5 text-sm font-semibold text-white active:scale-[0.98] transition-transform"
        >
          <Calculator size={16} strokeWidth={2} /> {lang === "es" ? "Cotiza ahora" : "Get a Quote"}
        </Link>
        <a
          href={`https://wa.me/${digits}?text=${prefill}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-bar-whatsapp"
          className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-sage bg-sage-light px-4 py-2.5 text-sm font-semibold text-charcoal-800 active:scale-[0.98] transition-transform"
        >
          <MessageCircle size={16} strokeWidth={2} /> WhatsApp
        </a>
      </div>
    </>
  );
}
